import dynamic from 'next/dynamic'
import { ComponentPropsWithoutRef, ReactNode } from 'react'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogPaper
} from '@/modules/components/ui/dialog'
import { cn } from '~shared/utils/cn'
import Image from 'next/image'
import giftHeart from '~widgets/banners/assets/gift_heart.png'

const LeadForm = dynamic(() => import('./lead-form').then(m => m.LeadForm), {
  ssr: false,
  loading: () => null
})

type ProgramDataForLead = {
  program?: {
    productId: number | null
    productName: string
    productCategory: string
    productFaculty: string
    institute?: string
  }
}

type Props = {
  children?: ReactNode
  buttonText?: string
  mainText?: string
  isBaner?: boolean
  formanaim?: string
  chatBotLink?: string
} & ProgramDataForLead &
  ComponentPropsWithoutRef<typeof Dialog>

export const LeadFormDialog = ({
  children,
  isBaner,
  formanaim,
  open,
  mainText,
  buttonText,
  chatBotLink,
  program,
  onOpenChange,
  ...rest
}: Props) => {
  return (
    <Dialog {...rest} open={open} onOpenChange={onOpenChange}>
      <DialogContent className=''>
        <DialogClose />
        <DialogPaper className='box-border w-full md:w-[704px] relative overflow-hidden'>
          {isBaner && (
            <Image
              alt='подарок с сердцем митм'
              src={giftHeart.src}
              quality={90}
              width={giftHeart.width}
              height={giftHeart.height}
              className={cn(
                'absolute top-0 right-0 z-0 pointer-events-none select-none hidden md:block',
                'w-[140px] h-auto',
                'md:w-[200px]'
              )}
            />
          )}
          <p
            className={cn(
              'text-[30px] md:text-[40px] font-medium leading-[1] tracking-[-0.04em]',
              isBaner ? 'mb-[16px] relative z-10 md:max-w-[500px]' : 'mb-[24px]'
            )}>
            {mainText ??
              `Заполните форму и\u00A0наш менеджер свяжется с\u00A0вами`}
          </p>
          {/* {isBaner ? (
            <p className='text-[#6A6A6A] mb-[24px] max-w-[300px]'>
              и заберите гайд «Как начать учёбу, чтобы не выгореть в первый
              месяц»
            </p>
          ) : null} */}
          {open && (
            <LeadForm
              formanaim={formanaim}
              chatBotLink={chatBotLink}
              className='w-full sizin relative z-10'
              isSpecialOffer={isBaner}
              buttonText={buttonText ?? 'Записаться на курс'}
              inputClassName='bg-secondary box-border'
              onSuccess={() => onOpenChange?.(false)}
              program={program}
            />
          )}
        </DialogPaper>
      </DialogContent>
    </Dialog>
  )
}
